import { render } from "./Empty_Dialog.vue?vue&type=template&id=67c6706a&scoped=true"
import script from "./Empty_Dialog.vue?vue&type=script&lang=js"
export * from "./Empty_Dialog.vue?vue&type=script&lang=js"

import "./Empty_Dialog.vue?vue&type=style&index=0&id=67c6706a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c6706a"]])

export default __exports__